import { render, staticRenderFns } from "./EditSyntheticMedia.vue?vue&type=template&id=15bcc69c&scoped=true"
import script from "./EditSyntheticMedia.vue?vue&type=script&lang=js"
export * from "./EditSyntheticMedia.vue?vue&type=script&lang=js"
import style0 from "./EditSyntheticMedia.vue?vue&type=style&index=0&id=15bcc69c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bcc69c",
  null
  
)

export default component.exports